import { render, staticRenderFns } from "./DisclaimerPage.vue?vue&type=template&id=2e03794a&scoped=true"
import script from "./DisclaimerPage.vue?vue&type=script&lang=ts"
export * from "./DisclaimerPage.vue?vue&type=script&lang=ts"
import style0 from "./DisclaimerPage.vue?vue&type=style&index=0&id=2e03794a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e03794a",
  null
  
)

export default component.exports